export default __webpack_public_path__ + "static/media/powerreader_locked_crown.98730a7c.svg";